import { ComponentType, ReactNode } from 'react';
import styled from 'styled-components';

import { Box } from '../../common/ui/Box';
import { theme } from '../../common/ui/theme';
import { Text } from '../Text/Text';

const IconWrapper = styled.div`
    background-color: ${theme.colors.background.subtle};
    padding: ${theme.space[8]};
    border-radius: 8px;
`;

interface StatePlaceholderProps {
    title: string;
    description: string;
    Icon: ComponentType<{ width?: number; height?: number; color?: string }>;
    action?: ReactNode;
}

export const StatePlaceholder = ({ title, description, Icon, action }: StatePlaceholderProps) => {
    return (
        <Box display="flex" flexDirection="column" alignItems="flex-start" maxWidth="420px">
            <IconWrapper>
                <Icon height={24} width={24} color={theme.colors.foreground.subtle} />
            </IconWrapper>

            <Text variant="title" marginTop={16}>
                {title}
            </Text>

            <Text variant="body" marginTop={4} marginBottom={24} color="foreground.subtle">
                {description}
            </Text>

            {action ? action : null}
        </Box>
    );
};
